(() => {
  function scrollActiveTabIntoView(section, tab, direction) {
    const tabs = section.querySelector('.tabbed-image-with-text__tabs');

    if (!tabs || window.matchMedia('(min-width: 768px)').matches) {
      return;
    }

    const tabLeft = tab.offsetLeft;
    const tabWidth = tab.offsetWidth;
    const containerWidth = tabs.clientWidth;

    /*
     * Leave part of the neighbouring tab visible.
     * Forward: show a little of the next tab.
     * Backward: show a little of the previous tab.
     */
    const peek = 48;

    let targetScroll;

    if (direction === 'backward') {
      targetScroll = tabLeft - peek;
    } else {
      targetScroll =
        tabLeft -
        (containerWidth - tabWidth - peek);
    }

    const maxScroll = tabs.scrollWidth - containerWidth;

    targetScroll = Math.max(
      0,
      Math.min(targetScroll, maxScroll)
    );

    tabs.scrollTo({
      left: targetScroll,
      behavior: 'smooth'
    });
  }

  function activateTab(section, tabId) {
    const tabs = Array.from(
      section.querySelectorAll('[data-tabbed-image-with-text-tab]')
    );

    const currentIndex = tabs.findIndex(
      (tab) => tab.getAttribute('aria-selected') === 'true'
    );

    const newIndex = tabs.findIndex(
      (tab) => tab.dataset.tabbedImageWithTextTab === tabId
    );

    const direction =
      newIndex < currentIndex ? 'backward' : 'forward';

    tabs.forEach((tab) => {
      const isActive =
        tab.dataset.tabbedImageWithTextTab === tabId;

      tab.setAttribute('aria-selected', String(isActive));

      if (isActive) {
        scrollActiveTabIntoView(section, tab, direction);
      }
    });

    section
      .querySelectorAll('[data-tabbed-image-with-text-panel]')
      .forEach((panel) => {
        panel.classList.toggle(
          'is-active',
          panel.dataset.tabbedImageWithTextPanel === tabId
        );
      });
  }

  function initSection(section) {
    if (section.dataset.tabsInitialised === 'true') {
      return;
    }

    section.dataset.tabsInitialised = 'true';

    section
      .querySelectorAll('[data-tabbed-image-with-text-tab]')
      .forEach((tab) => {
        tab.addEventListener('click', () => {
          activateTab(
            section,
            tab.dataset.tabbedImageWithTextTab
          );
        });
      });
  }

  document
    .querySelectorAll('[data-tabbed-image-with-text]')
    .forEach(initSection);

  document.addEventListener('shopify:section:load', (event) => {
    event.target
      .querySelectorAll('[data-tabbed-image-with-text]')
      .forEach(initSection);
  });
})();